import { render, staticRenderFns } from "./studentManage.vue?vue&type=template&id=b9d7c61c&"
import script from "./studentManage.vue?vue&type=script&lang=js&"
export * from "./studentManage.vue?vue&type=script&lang=js&"
import style0 from "./studentManage.vue?vue&type=style&index=0&id=b9d7c61c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports